/*jshint esversion:6 */
import React from 'react';
import Select, { Creatable } from 'react-select';
import Toaster from 'toastr';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Util from '../../../util/util';
import ArbiterApi from '../../../api/ArbiterApi';
import Modal from '../../common/modal';
import FloatInput from '../../common/floatInput';
import CButton from '../../common/connectedButton';
import validatorhelpers from '../../common/validatorhelpers';

class TransactionTypesModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: props.isNew,
            isView: !props.isNew,
            transactionType: props.isNew ? { settlementDetailsAvailable: false } : props.transactionType,
            groups: [],
            channels: [],
            disputableResponseCodes: [],
            title: props.isNew ? "New Transaction Type" : `${props.transactionType.name}`,
            updating: false,
            touchedForm: false,
            selectedTransactionGroup: null,
            selectedChannel: null,
            transactionGroupValidity: -1,
            nameValidity: -1,
            channelValidity: -1,
            disputableResponseCodesValidity: -1

        };

        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                bottom: "150px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onTransactionGroupChange = this.onTransactionGroupChange.bind(this);
        this.onChannelChange = this.onChannelChange.bind(this);
        this.onDisputableResponseCodesChange = this.onDisputableResponseCodesChange.bind(this);

    }

    onTextInputChange(evt) {

        let transactionType = Object.assign({}, this.state.transactionType);
        transactionType[evt.target.id] = evt.target.value || null;
        let stateUpdate = {
            transactionType,
            touchedForm: true
        };
        stateUpdate[`${evt.target.id}Validity`] = evt ? 1 : 0;
        this.setState(stateUpdate);
    }
    onTransactionGroupChange(evt) {

        let channels = evt && evt.channels ? Object.keys(evt.channels).map((channel) => {
            let c = evt.channels[channel];
            if (c) {
                c.label = channel;
                c.value = channel;
            }
            return c;
        }) : [];
        let transactionType = Object.assign({}, this.state.transactionType);
        transactionType.groupId = evt ? evt.id : null;
        this.setState({
            transactionType,
            selectedTransactionGroup: evt,
            selectedChannel: null,
            channels,
            touchedForm: true,
            transactionGroupValidity: evt ? 1 : 0


        });
    }

    onChannelChange(evt) {

        let transactionType = Object.assign({}, this.state.transactionType);
        transactionType.groupId = evt ? evt.id : null;

        this.setState({
            transactionType,
            selectedChannel: evt,
            touchedForm: true,
            channelValidity: evt ? 1 : 0
        });
    }

    onDisputableResponseCodesChange(evt) {

        let transactionType = Object.assign({}, this.state.transactionType);

        //Remove any parameter that contains space then flatten
        let filteredOptions = evt ? evt.filter(val => { return (val.value.trim().indexOf(" ") === -1) }) : []
        transactionType.disputableResponseCodes = filteredOptions.map(obj => (obj.value.trim()));

        this.setState({
            transactionType,
            disputableResponseCodes: filteredOptions,
            disputableResponseCodesValidity: filteredOptions.length > 0 ? 1 : 0,
            touchedForm: true
        });
    }

    componentDidMount() {
        ArbiterApi.getTransactionGroups()
            .then(response => {
                let selectedTransactionGroup = null;
                let channels = [];
                let selectedChannel = null;
                let groups = response.data.map(obj => {

                    obj.label = obj.name;
                    obj.value = obj.name;
                    if (this.state.transactionType.group === obj.name) {
                        selectedTransactionGroup = obj;
                        if (selectedTransactionGroup.channels)
                            channels = Object.keys(selectedTransactionGroup.channels).map(channel => {

                                let cObj = selectedTransactionGroup.channels[channel]
                                cObj.label = channel;
                                cObj.value = channel;
                                if (cObj.id === this.state.transactionType.groupId) {
                                    selectedChannel = cObj;
                                }
                                return cObj;
                            }
                            );

                    }
                    return obj;

                });

                if (!this.state.isNew && this.state.transactionType.disputableResponseCodes) {
                    this.setState({ disputableResponseCodes: this.state.transactionType.disputableResponseCodes.map(val => ({ label: val, value: val })) })
                }

                this.setState({ groups, selectedTransactionGroup, selectedChannel, channels });
            })
            .catch(error => {
                 Util.errorMessageToast(Toaster, error.data,
                    [` ${Messages.ERROR_TRANSACTION_GROUPS}`] 
                );
            });
    }
    handleAction(evt) {
  
        this.setState({ updating: true });

        const transactionType = this.state.transactionType;
        const isNew = this.state.isNew;
        let promise = this.state.isNew ? ArbiterApi.createTransactionType(transactionType) : ArbiterApi.updateTransactionType(transactionType.id, transactionType);
        promise.then((response) => {
            Toaster.success(`Transaction Type  '${this.state.transactionType.name}' - successfully  ${isNew ? 'created' : 'updated'}`);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {

                Util.errorMessageToast(Toaster, error.data, [`${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_TRANSACTION_TYPE_UPDATE} `]);
                this.setState({ updating: false });
            })
    }


    render() {
        const isNew = this.state.isNew;
        const isView = this.state.isView;
        return (
            <Modal title={this.state.title} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                {isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label>Name:</label>
                                        <label>{this.state.transactionType.name}</label>
                                    </div>

                                    <div className="form-div">
                                        <label>Transaction Group:</label>
                                        <label>{this.state.transactionType.group}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Channel:</label>
                                        <label>{this.state.transactionType.channel}</label>
                                    </div>
                                    <div className="form-div">
                                        <label>Disputable Response Codes:</label>
                                        <label>{this.state.transactionType.disputableResponseCodes.join(",")}</label>
                                    </div>
                                    

                                </div>
                            </div>
                        </form>
                    </div>
                }
                {!isView &&
                    <div className="mod-content">
                        <form>
                            <div className="row">
                                <div className="col-md-11">
                                    <div className="form-div">
                                        <label className="required">Name</label>
                                        <FloatInput
                                            id="name"
                                            value={this.state.transactionType.name}
                                            onChange={this.onTextInputChange}
                                            placeholder="Enter Name"
                                            disabled={!isNew}
                                            showError={this.state.nameValidity === 0} errorMessage={`${Messages.INVALID_NAME}`}
                                        />
                                    </div>


                                    <div className="form-div">
                                        <label className="required">Transaction Group</label>
                                        <Select
                                            id="transactionGroup"
                                            value={this.state.selectedTransactionGroup}
                                            options={this.state.groups}
                                            onChange={this.onTransactionGroupChange}
                                            placeholder="Select Transaction Group"
                                        />
                                    </div>

                                    <div className="form-div">
                                        <label className="required">Channel</label>
                                        <Select
                                            id="channel"
                                            value={this.state.selectedChannel}
                                            options={this.state.channels}
                                            onChange={this.onChannelChange}
                                            placeholder="Select Channel"
                                        />
                                    </div>

                                    <div className="form-div">
                                        <label className="required">Disputable Response Codes</label>
                                        <Creatable
                                            id="disputableResponseCodes"
                                            placeholder="Enter codes (Comma Seperated)"
                                            onChange={this.onDisputableResponseCodesChange}
                                            multi={true}
                                            options={[]}
                                            value={this.state.disputableResponseCodes}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                }
                <div className="mod-footer">
                    <div className="mod-footer-buttons">
                        {isView &&
                            <CButton
                                onClick={(evt) => { this.setState({ isView: false }) }}
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.UPDATE_TRANSACTION_TYPE]}>EDIT</CButton>
                        }
                        {!isView && isNew &&
                            <CButton
                                onClick={(evt) => { this.handleAction(evt); }}
                                disabled={this.state.updating || !this.formValid()}
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.CREATE_TRANSACTION_TYPE]}>CREATE</CButton>

                        }
                        {!isView && !isNew &&
                            <CButton
                                onClick={(evt) => { this.handleAction(evt); }}
                                disabled={this.state.updating || !this.formValid()}
                                className="btn btn-primary"
                                allowedPermissions={[Permissions.UPDATE_TRANSACTION_TYPE]}>UPDATE</CButton>

                        }
                        <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>
                    </div>
                </div>
            </Modal>
        )
    }

    formValid() {
        if (this.state.isNew)
            //Each field must have an exact validity i.e. validity must exact equal '1'
            return this.state.touchedForm && this.state.nameValidity === 1 && this.state.disputableResponseCodesValidity === 1 && this.state.transactionGroupValidity === 1 && this.state.channelValidity === 1 && !validatorhelpers.isEmpty(this.state.selectedChannel)
        //all fields must be valid i.e validity must be 1 or -1 (for untouched fields)
        return this.state.touchedForm && this.state.disputableResponseCodesValidity && this.state.transactionGroupValidity && this.state.channelValidity;
    }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(TransactionTypesModal, [Permissions.VIEW_TRANSACTION_TYPE]));


// WEBPACK FOOTER //
// ./src/components/admin/transactionTypes/transactionTypesModal.js